import { HTMLAttributes } from "react";

import ThaloLogo from "@/assets/thalo-light.png";
import { cn } from "@/lib/utils";
import { InstallFlowNav } from "./install-flow-nav";

interface AuthFrameProps extends HTMLAttributes<HTMLDivElement> {}

export function AprovedInstallflowFrame({
  className,
  ...props
}: AuthFrameProps) {
  return (
    <div className="w-full h-screen animate-bg-pan-br">
      <div className="flex-none">
        <InstallFlowNav />
      </div>
      <div className="flex-1 items-center justify-center h-screen p-6 w-full bg-white">
        <div className="flex flex-col items-center justify-center ">
          <div
            className={cn(
              "h-full w-full flex flex-col items-center justify-around pt-6",
              className,
            )}
            {...props}
          >
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}
